import { render, staticRenderFns } from "./fiche.vue?vue&type=template&id=4746443c"
import script from "./fiche.vue?vue&type=script&lang=js"
export * from "./fiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports